<template>
  <v-dialog
  :value="value"
  @input="$emit('input')">
    <v-card class="pb-2">
      <v-card-title>
        <span class="headline">
          <v-icon>mdi-file-check</v-icon> Invoices
        </span>
      </v-card-title>
      <v-card-text>
        <v-row class="mt-3 no-gutters">
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-row class="mb-3 mt-3">
              <v-col cols="12" sm="6" md="6" lg="6">
                <!-- <v-btn color="success" class="mb-2" v-if="!disableSaveEdit" @click="saveChanges()">Save Changes</v-btn>
                <v-btn color="warning" class="mb-2" v-if="!disableSaveEdit" @click="cancelEdit()">Cancel</v-btn> -->
                <div v-if="selectedItems && selectedItems.length > 0">
                  <v-btn color="error" class="mb-2" small @click="deleteInvoice(selectedItems)">
                    <v-icon color="white" small>mdi-delete</v-icon> Delete
                  </v-btn>
                  <v-btn
                    small
                    class="mb-2"
                    color="warning"
                    @click="downloadInvoices()"
                  >
                  <v-icon color="white" small>mdi-download</v-icon> Download ({{selectedItems.length}})
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" sm="3" md="3" lg="3" style="margin-top:8px;">
                <v-menu
                  ref="monthPicker"
                  v-model="filter.monthPicker"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  dense
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Uploaded Date"
                      v-model="filter.searchMonth"
                      readonly
                      clearable
                      outlined
                      dense
                      hide-details="auto"
                      v-bind="attrs"
                      v-on="on"
                      @change="searchFilter()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filter.searchMonth"
                    type="month"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="secondary"
                        @click="cancelMonth()"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="secondary"
                        @click="searchMonthOk()"
                    >
                        OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3" md="3" lg="3">
                <v-text-field
                  v-model="filter.search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-data-table
              :headers="headers"
              :items="filteredItems"
              :items-per-page="10"
              :search="filter.search"
              :no-data-text="'Empty list'"
              class="table-small elevation-1"
              :key="dataTableKey"
              show-select
              :single-select="false"
              @toggle-select-all="selectAllItems"
            >
              <template v-slot:[`item.data-table-select`]="{item}">
                <v-checkbox
                  class="custom-checkbox"
                  v-model="selectedItems"
                  label=""
                  :value="item"
                  color="grey darken-2"
                ></v-checkbox>
              </template>
              <template v-slot:[`item.handle`]="{ item }">
                <td class="text-left">
                  <social-handle
                    :isTikTok="item.platform === 'tiktok'"
                    :isInstagram="item.platform === 'instagram'"
                    :tiktokHandle="item.handle"
                    :instagramHandle="item.handle"
                  />
                </td>
              </template>
              <template v-slot:[`item.swiftCode`]="{ item }">
                <div class="item-edit" @click="openEditItem(item, 'swiftCode')" v-if="item.swiftCodeEdit === false">
                  <td class="text-xs-left" style="min-width:75px">{{item.swiftCode}}</td>
                </div>
                <div v-else>
                  <v-text-field
                    class="input-field mt-3"
                    v-model="item.swiftCode"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </div>
              </template>
              <template v-slot:[`item.bankAccount`]="{ item }">
                <div class="item-edit" @click="openEditItem(item, 'bankAccount')" v-if="item.bankAccountEdit === false">
                  <td class="text-xs-left" style="min-width:75px">{{item.bankAccount}}</td>
                </div>
                <div v-else>
                  <v-text-field
                    class="input-field mt-3"
                    v-model="item.bankAccount"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </div>
              </template>
              <template v-slot:[`item.username`]="{ item }">
                <div class="item-edit" @click="openEditItem(item, 'username')" v-if="item.usernameEdit === false">
                  <td class="text-xs-left" style="min-width:75px">{{item.username}}</td>
                </div>
                <div v-else>
                  <v-text-field
                    class="input-field mt-3"
                    v-model="item.username"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </div>
              </template>
              <template v-slot:[`item.amount`]="{ item }">
                <div class="item-edit">
                  <td class="text-xs-left" style="min-width:75px">
                    {{item.amount || '-'}}
                    <v-icon small color="warning" data-toggle="tooltip" data-placement="bottom" title="Include GST 9%" v-if="item.GST">mdi-alert-circle-outline</v-icon>
                  </td>
                </div>
              </template>
              <!-- <template v-slot:[`item.paymentStatus`]="{ item }">
                <div @click="openEditItem(item, 'paymentStatus')" v-if="item.paymentStatusEdit === false">
                  <td class="text-xs-left" style="min-width:50px">{{formatPaymentStatus(item.paymentStatus)}}</td>
                </div>
                <div v-else>
                  <td class="text-xs-left" style="min-width:50px">
                    <v-select
                      class="input-field pt-3"
                      v-model="item.paymentStatus"
                      :items="allowedStatuses"
                      item-value="status"
                      item-text="display"
                      label="Payment Status"
                      dense
                      outlined
                      @change="changePaymentStatus(item)"
                    ></v-select>
                  </td>
                </div>
              </template>
              <template v-slot:[`item.paymentDate`]="{ item }">
                <div class="item-edit" @click="openEditItem(item, 'paymentDate')" v-if="item.paymentDateEdit === false">
                  <td class="text-xs-left" style="min-width:75px">{{item.paymentDate || '-'}}</td>
                </div>
                <div v-else>
                  <v-text-field
                    class="input-field mt-3"
                    v-model="item.paymentDate"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </div>
              </template>
              <template v-slot:[`item.bankReference`]="{ item }">
                <div class="item-edit" @click="openEditItem(item, 'bankReference')" v-if="item.bankReferenceEdit === false">
                  <td class="text-xs-left" style="min-width:75px">{{item.bankReference || '-'}}</td>
                </div>
                <div v-else>
                  <v-text-field
                    class="input-field mt-3"
                    v-model="item.bankReference"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </div>
              </template> -->
              <template v-slot:[`item.remarks`]="{ item }">
                <div class="item-edit" @click="openEditItem(item, 'remarks')" v-if="item.remarksEdit === false">
                  <td class="text-xs-left" style="min-width:75px">{{item.remarks || '-'}}</td>
                </div>
                <div v-else>
                  <v-text-field
                    class="input-field mt-3"
                    v-model="item.remarks"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </div>
              </template>
              <template v-slot:[`item.createdAt`]="{ item }">
                <div class="item-edit">
                  <td class="text-xs-left" style="min-width:75px">
                    {{utils.formatCustomDate(item.createdAt, 'DD/MM/YYYY')}}
                  </td>
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn
                  data-toggle="tooltip"
                  data-placement="top"
                  title="View Invoice"
                  :href="item.invoice.url"
                  color="info"
                  class="ims-action"
                  target="_blank"
                >
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
                <v-btn color="warning" class="ims-action mb-2" style="height:36px" small @click="openEditModal(item)">
                  <v-icon color="white" small>edit</v-icon>
                </v-btn>
                <v-btn color="error" class="ims-action mb-2" style="height:36px" small @click="deleteInvoice([item])">
                  <v-icon color="white" small>mdi-delete</v-icon>
                </v-btn>
                <!-- <v-badge
                  @click.stop="openReportNotesDialog(item)"
                  :value="getNoteUnreadCount(item)"
                  :content="getNoteUnreadCount(item)"
                  color="green"
                  overlap
                >
                  <v-btn
                  class="ims-action"
                  @click.stop="openReportNotesDialog(item)"
                  color="warning"
                  small>
                    <v-icon color="white" small>edit</v-icon>
                  </v-btn>
                </v-badge> -->
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          @click="close()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import SocialHandle from '@/components/scoped/custom/SocialHandle';
import campaignAPIs from '../Campaign/campaignAPIs';
import userAPIs from '../User/userAPIs';
import utils from '../../../utils';
import config from '@/config';
export default {
  name: 'UploadedInvoiceListModal',
  props: ['value'],
  components: {
    SocialHandle
  },
  data () {
    return {
      utils: utils.func,
      filteredItems: [],
      selectedItems: [],
      headers: [
        {value: 'handle', text: 'IG Handle/Tiktok Handle', sortable: true},
        {value: 'swiftCode', text: 'Swift Code', sortable: true},
        {value: 'bankAccount', text: 'Bank A/C No.', sortable: true},
        {value: 'username', text: 'Payee Name', sortable: true},
        {value: 'amount', text: 'Amount', sortable: true},
        {value: 'clientName', text: 'Client Name', sortable: true},
        {value: 'campaignName', text: 'Campaign Name', sortable: true},
        {value: 'IONumber', text: 'Campaign IO Number', sortable: true},
        {value: 'CO', text: 'CC', sortable: true},
        {value: 'remarks', text: 'Remark', sortable: true},
        // {value: 'paymentDate', text: 'Payment Date', sortable: true},
        // {value: 'paymentStatus', text: 'Payment Status', sortable: true},
        // {value: 'bankReference', text: 'Bank Reference', sortable: true},
        {value: 'createdAt', text: 'Uploaded Date (DD/MM/YYYY)', sortable: true},
        {value: 'action', text: 'Actions', sortable: true}
      ],
      filter: {
        search: '',
        searchMonth: '',
        selectedMonth: '',
        monthPicker: false
      },
      panel: [0],
      disableSaveEdit: false,
      loading: false,
      CO: []
      // financeColumns: [
      //   'paymentDate',
      //   'paymentStatus',
      //   'bankReference'
      // ]
    }
  },
  computed: {
    ...mapState({
      items: state => state.campaign.invoiceLists,
      invoiceDeleteSuccess: state => state.campaign.invoiceDeleteSuccess,
      paymentStatuses: state => state.payment.status
    }),
    ...mapGetters('payment', [
      'paymentStatusOptions',
      'allowedStatuses'
    ]),
    currentUserID: function () {
      return this.$store.state.user.id;
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    isFinance: function() {
      if (this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH ||
        this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW ||
        this.currentUserRole === config.userRoles.FINANCE
      ) {
        return true;
      }
      return false;
    }
  },
  watch: {
    value: async function(value) {
      if (value) {
        // Invoice formatting uses CO names, so preserve this dependency order.
        await this.getCOs()
        await this.getUploadedInvoiceLists()
      }
    }
  },
  methods: {
    async getUploadedInvoiceLists() {
      this.isLoading = true;
      await this.$store.dispatch('campaign/getUploadedInvoiceLists')
      this.filteredItems = Object.assign([], this.items)
      this.filteredItems = this.filteredItems.map(item => {
        item.CO = this.CO.filter(co => item.assignedTo && item.assignedTo.includes(co.id)).map(co => co.name).join(', ')
        return item
      })
      this.cancelEdit()
      this.isLoading = false;
      this.selectedItems = []
    },
    openEditItem(item, itemName) {
      // if (!this.isFinance && this.financeColumns.includes(itemName)) return false
      item[itemName + 'Edit'] = true
      item.editInvoice = true
      this.disableSaveEdit = false
      this.filteredItems = Object.assign([], this.filteredItems)
    },
    saveChanges() {
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          this.isLoading = true;
          let data = this.buildData()
          // Submit request to save edited invoice data
          campaignAPIs
          .updateReportInvoice(data)
          .then(response => {
            // Update submitting status
            this.isLoading = false;
            this.cancelEdit()
            // Show success message
            this.$swal({
              text: 'Invoice Updated',
              type: 'success'
            });
            this.getUploadedInvoiceLists()
            this.$emit('updated')
            this.$emit('input');
          })
          .catch(error => {
            // Update submitting status
            this.isLoading = false;
            // Request failed.
            console.log('error', error);
            this.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    buildData() {
      let data = this.filteredItems.filter(item => {
        if (this.checkInvoiceUpdate(item)) return true
        return false
      })
      data = data.map(item => {
        return Object.assign({}, {
          id: item.id,
          influencerID: item.influencerID,
          handle: item.handle,
          campaignID: item.campaignID,
          swift_code: item.swiftCode,
          bank_account: item.bankAccount,
          fullName: item.username,
          amount: parseInt(item.amount),
          payment_date: item.paymentDate,
          payment_status: item.paymentStatus,
          bank_reference: item.bankReference,
          remarks: item.remarks
        })
      })
      return data
    },
    formatPaymentStatus(statusVal) {
      let statusText = '-'
      Object.entries(this.paymentStatuses).forEach(item => {
        if (statusVal === item[1].value) {
          statusText = item[1].text
        }
      });
      return statusText
    },
    searchFilter() {
      this.filteredItems = Object.assign([], this.items)
      if (this.filter.searchMonth) {
        this.filteredItems = this.items.filter(b => {
          let searchMonth = this.utils.formatCustomDate(b.createdAt, 'YYYY-MM')
          // console.log(searchMonth, this.filter.searchMonth)
          return searchMonth === this.filter.searchMonth
        })
      }
    },
    cancelEdit() {
      this.filteredItems = this.filteredItems.map(item => {
        item = this.setDefaultEditFields(item)
        return item
      })
      this.disableSaveEdit = true
    },
    setDefaultEditFields(obj) {
      obj.swiftCodeEdit = false;
      obj.bankAccountEdit = false;
      obj.usernameEdit = false;
      obj.paymentDateEdit = false;
      obj.bankReferenceEdit = false;
      obj.paymentStatusEdit = false;
      obj.remarksEdit = false;
      obj.editInvoice = false;
      return obj;
    },
    changePaymentStatus(item) {
      if (!this.checkPaymentStatus(item)) {
        this.$swal({
          text: `Please Enter SwiftCode, Bank Account and Payee Name.`,
          type: 'warning'
        })
      }
    },
    checkPaymentStatus(item) {
      if ((!item.swiftCode || !item.bankAccount || !item.username) &&
      item.paymentStatus === this.paymentStatuses.PAID.value) return false
      return item.editInvoice || false
    },
    checkInvoiceUpdate(item) {
      let isInvoiceValid = true
      if (!item.editInvoice || item.editInvoice === false) {
        isInvoiceValid = false
      }
      isInvoiceValid = this.checkPaymentStatus(item)
      return isInvoiceValid
    },
    async downloadInvoices() {
      for (let item of this.selectedItems) {
        if (item.invoice) {
          await utils.func.downloadFile(`${item.handle}_invoice`, item.invoice.url)
        }
      }
    },
    selectAllItems($event) {
      if (($event.value && $event.items.length === 0) || !$event.value) {
        this.selectedItems = [];
        return;
      }
      if (this.selectedItems.length === 0) {
        this.selectedItems = $event.items
      } else this.selectedItems = []
    },
    // changeSearch(keyword) {
    //   this.workingSearch = keyword
    // },
    searchMonthOk() {
      // this.$refs.monthPicker.save(batch.filter.searchMonth);
      this.filter.monthPicker = false
      this.searchFilter();
    },
    cancelMonth() {
      this.filter.monthPicker = false
      this.filter.searchMonth = ''
      this.searchFilter()
    },
    async deleteInvoice(items) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to delete?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          let selectedIds = items.map(item => item.id)
          await this.$store.dispatch('campaign/deleteInvoiceByIds', {
            ids: selectedIds
          })
          if (this.invoiceDeleteSuccess) {
            // Show success message
            this.$swal({
              text: 'Invoice Deleted',
              type: 'success'
            });
            this.getUploadedInvoiceLists()
            this.$emit('updated')
            this.$emit('input')
          }
        }
      })
    },
    async openEditModal(item) {
      this.close()
      item.instagram = item.handle
      item.paymentSubmissionDate = item.payment_submission_date
      item.update = true
      this.$emit('openEdit', item)
    },
    async getCOs() {
      // Get all CO by role
      let response = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
      if (response) {
        this.CO = response.users
        this.CO = this.CO.map(co => {
          co.name = `${co.firstName} ${co.lastName}`
          return co
        })
      }
    },
    close() {
      this.$emit('input');
    }
  }
}
</script>
<style scoped>
  .table-small tbody td {
    padding: 5px!important;
  }
  .table-small tbody td .input-field {
    font-size:13px;
  }
  .table-small tbody td .custom-checkbox {
    padding: 0 16px;
  }
  .item-edit {
    min-width: 75px;
    min-height: 75px;
    padding-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// UploadedInvoiceListModal.vue?516159e0